/** Public rules for fictional local practice. All accounting happens on the server. */
export const PRACTICE_ENTRIES = [200, 500, 1000, 2000] as const;
export type PracticeEntry = typeof PRACTICE_ENTRIES[number];

export function isPracticeEntry(value: number): value is PracticeEntry {
    return PRACTICE_ENTRIES.some(entry => entry === value);
}

export function practiceEntryForRoom(id: number): PracticeEntry {
    const entry = PRACTICE_ENTRIES[id];
    if (entry === undefined) throw new Error(`Unknown practice arena: ${id}`);
    return entry;
}

export function practiceFee(entry: PracticeEntry): number {
    return entry * 15 / 100;
}
